import { useEffect, useState } from "react";
import PriceContainer from "../PriceContainer";
import Link from "next/link";
import AvailableSeasonTooltip from "./AvailableSeasonTooltip";
import CartIcon from "../icons/CartIcon";
import { useRouter } from "next/router";

export default function SingleProductListItem({
  product,
  userInfo,
  toggleOverlay,
}) {
  const [image, setImage] = useState("/assets/image/placeholder-logo.jpg");
  const router = useRouter();

  useEffect(() => {
    setImage("/assets/image/placeholder-logo.jpg");

    let variantImage = null;
    if (product?.variantImages?.length > 0) {
      variantImage = product.variantImages.find((file) => file?.filePath);
      if (variantImage) {
        setImage(
          `https://${process.env.NEXT_PUBLIC_PADDAP_STORAGE_NAME}.blob.core.windows.net/pictures/${variantImage.filePath}`
        );
        return;
      }

      findImage();
      return;
    }

    let productImage = null;
    if (product?.product?.productImages?.length > 0) {
      productImage = product.product.productImages.find(
        (file) => file?.filePath
      );

      if (productImage) {
        setImage(
          `https://${process.env.NEXT_PUBLIC_PADDAP_STORAGE_NAME}.blob.core.windows.net/pictures/${productImage.filePath}`
        );
        return;
      }

      findImage();
      return;
    }

    findImage();
  }, [product]);

  const findImage = async () => {
    let imageId = await fetch(
      process.env.NEXT_PUBLIC_CRAFT_BASE_URL +
        "/api/products/images/" +
        product?.vitemId +
        "?single=1",
      {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    ).then((response) => response.json());

    if (imageId && imageId?.img?.length > 0) {
      setImage(imageId?.img);
    }
  };

  // TODO: set back if scroll to product is needed
  // const goToProduct = (e) => {
  //   e.preventDefault();

  //   let [base, params] = router.asPath.split("?");

  //   if (base.includes("#")) {
  //     base = base.split("#")[0];
  //   }

  //   const newUrl = `${base}#${product.craft_commerce_element_uid}?${params}`;
  //   router.push(newUrl, undefined, { shallow: true });
  //   router.push("/product/" + product.craft_commerce_element_uid);
  // };

  return (
    <Link legacyBehavior href={"/product/" + product.craft_commerce_element_uid}>
      <div className={"relative flex flex-col shadow cursor-pointer"}>
        <div className="absolute top-2 right-2 z-50 mb-2">
          <div
            onClick={(e) => {
              e.stopPropagation();
              toggleOverlay(product?.craft_commerce_element_uid);
            }}
            className={
              "w-[40px] h-[40px] flex justify-center items-center bg-olaf-green-700 rounded-full border-2 border-white"
            }
          >
            <CartIcon text={"Snel toevoegen"} color={"text-white"} />
          </div>

          {product?.availableSeason && (
            <AvailableSeasonTooltip
              availableSeason={product?.availableSeason}
            />
          )}
        </div>

        <div className="w-full overflow-hidden" style={{ height: "350px" }}>
          <img
            src={image}
            alt="product afbeelding"
            className="h-full w-full object-cover"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = "/assets/image/placeholder.jpg";
            }}
          />
        </div>
        <div className="flex-grow w-full bg-olaf-green-500/75 px-2 py-4 flex flex-col items-start relative flex-grow-1">
          <h3 className="text-sm leading-4 font-bold text-white mr-2 mb-2">
            {product.name}
          </h3>

          <div className={"flex w-full gap-2 justify-self-start mb-2"}>
            {(product?.dimensionOne?.name ?? product.dimension1) && (
              <span
                className={
                  "text-[10px] lg:text-xs bg-white rounded-md pb-1 pt-1 pl-2 pr-2 justify-self-end"
                }
              >
                {product?.dimensionOne?.name ?? product.dimension1}
              </span>
            )}

            {(product?.dimensionTwo?.name ?? product.dimension2) && (
              <span
                className={
                  "text-[10px] lg:text-xs bg-white rounded-md pb-1 pt-1 pl-2 pr-2 justify-self-end"
                }
              >
                {product?.dimensionTwo?.name ?? product.dimension2}
              </span>
            )}

            {(product?.dimensionThree?.name ?? product.dimension3) && (
              <span
                className={
                  "text-[10px] lg:text-xs bg-white rounded-md pb-1 pt-1 pl-2 pr-2 justify-self-end"
                }
              >
                {product?.dimensionThree?.name ?? product.dimension3}
              </span>
            )}
          </div>

          <div
            className={
              "grid grid-cols-2 w-full flex items-center justify-between gap-4 mt-auto"
            }
          >
            <div className={"justify-self-start"}>
              <PriceContainer
                maxPrice={product.adjusted_price / 100}
                minPrice={product.adjusted_price / 100}
                option={userInfo?.price_display_option}
                style={"font-bold"}
              />
              {product.StockRaalte > 0 && (
                <span className="ml-1 mt-1 text-[10px] lg:text-xs bg-white rounded-md pb-1 pt-1 pl-2 pr-2 justify-self-end">
                  Raalte: <b>{product.StockRaalte}</b>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
